<template>
  <div>
    <LoadingContainer v-if="loadingImageExams" />
    <v-data-table
      v-else
      ref="imageExamsTable"
      :headers="imageExamsTableHeaders"
      :items="imageExams"
      :items-per-page="15"
    >
      <template v-slot:item.actions="{ item }">
        <div class="d-flex">
          <div :style="{ order: buttonOrder('laudo') }" v-if="isButtonEnabled('laudo')">
            <ReportDialog :lau-isn="item.lau_isn" :pad-isn="item.id">
              <template v-slot:open="{ open }">
                <v-btn
                  @click="open"
                  small
                  icon
                  color="secondary"
                  :title="buttonLabel('laudo', 'Visualizar Laudo')"
                >
                  <v-icon size="21">mdi-clipboard-text</v-icon>
                </v-btn>
              </template>
            </ReportDialog>
          </div>
          <div
            :style="{ order: buttonOrder('anexo') }"
            v-if="showPdfImages && isButtonEnabled('anexo')"
          >
            <PacsButton :has-images="item.origin.imagem_pacs">
              <template v-slot:default="{ open, loading }">
                <v-btn
                  small
                  icon
                  :disabled="loading"
                  :title="buttonLabel('anexo', 'Imagens (PDF)')"
                  color="secondary"
                  @click.prevent="open(item.origin, true)"
                >
                  <v-icon size="21">mdi-file-download</v-icon>
                </v-btn>
              </template>
            </PacsButton>
          </div>
          <div
            :style="{ order: buttonOrder('pacs') }"
            v-if="isButtonEnabled('pacs')"
          >
            <PacsButton :has-images="item.origin.imagem_pacs">
              <template v-slot:default="{ open, loading }">
                <v-btn
                  small
                  icon
                  :disabled="loading"
                  :title="buttonLabel('pacs', 'Imagens (PACS)')"
                  color="secondary"
                  @click.prevent="open(item.origin)"
                >
                  <v-icon size="21">mdi-image</v-icon>
                </v-btn>
              </template>
            </PacsButton>
          </div>
        </div>
      </template>
      <template v-slot:item.status="{ item }">
        <ImageExamStatusLabel :lau_isn="item.lau_isn" />
      </template>
      <template v-slot:item.date="{ item }">
        {{ item.date | njDate }}
      </template>
      <template v-slot:item.prevision_date="{ item }">
        {{ reportExists(item.lau_isn) ? '' : item.prevision_date }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import ImageExamStatusLabel from '@/views/exams/ImageExamStatusLabel'
import LoadingContainer from '@/components/LoadingContainer'
import ReportDialog from '@/components/ReportDialog'
import PacsButton from '@/components/PacsButton'
import Api from '@/resources/NajaSocialApi'
import { orderBy } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'PatientImageExams',
  components: {
    PacsButton,
    ImageExamStatusLabel,
    LoadingContainer,
    ReportDialog,
  },

  computed: {
    ...mapState({
      showPdfImages: state => state.data.organization.show_pdf_images,
      portalExamsWithoutPACS: state => state.data.organization.portal_exams_without_pacs,
      portalCustomizeActions: state => state.data.organization.portal_customize_actions,
      portalActionsConfig: state => state.data.organization.portal_actions_config,
    }),

    profileActionsConfig() {
      if (!this.portalCustomizeActions || !this.portalActionsConfig) return null
      return this.portalActionsConfig[this.profileKey] || null
    },
  },

  data() {
    return {
      profileKey: 'patient',
      expanded: [],
      loadingImageExams: false,
      imageExamsTableHeaders: [
        { field: 'actions', value: 'actions', text: '' },
        { field: 'name', value: 'name', text: 'EXAME', width: '40%' },
        {
          field: 'doctor',
          value: 'doctor_requestor',
          text: 'MÉDICO SOLICITANTE',
        },
        { field: 'date', value: 'date', text: 'DATA DO EXAME' },
        { field: 'status', value: 'status', text: 'STATUS' },
        {
          field: 'prevision_date',
          value: 'prevision_date',
          text: 'PREVISÃO DE ENTREGA',
        },
      ],
      imageExams: [],
    }
  },

  mounted() {
    this.search()
  },

  methods: {
    isButtonEnabled(key) {
      if (!this.profileActionsConfig) return true
      const btn = this.profileActionsConfig.find(b => b.key === key)
      return btn ? btn.enabled : true
    },

    buttonOrder(key) {
      if (!this.profileActionsConfig) return 0
      const btn = this.profileActionsConfig.find(b => b.key === key)
      return btn ? parseInt(btn.position) : 0
    },

    buttonLabel(key, defaultLabel) {
      if (!this.profileActionsConfig) return defaultLabel
      const btn = this.profileActionsConfig.find(b => b.key === key)
      return btn && btn.label ? btn.label : defaultLabel
    },

    reportExists(lauISN) {
      return lauISN != undefined && lauISN != null && lauISN != 0
    },

    openMedicalReport(exam) {
      if (this.reportExists(exam.lau_isn)) {
        if (this.mobile) {
          const url = Api.medicalReportURL(exam.lau_isn)
          window.open(url, '_blank')
        } else {
          this.$refs.reportModal.open(exam.lau_isn, exam.origin.pad_isn)
        }
      } else {
        this.$toast.show('Laudo ainda não liberado para visualização', 'warn')
      }
    },

    async search(params = {}) {
      this.loadingImageExams = true

      try {
        const imageExamsResponse = await Api.imageExams(params)
        let exams = orderBy(
          imageExamsResponse.data.exams,
          exam => {
            return this.$moment(exam.date)
          },
          ['desc']
        )

        if (this.portalExamsWithoutPACS === 'dont_show_exams') {
          exams = exams.filter(x => x.origin.imagem_pacs)
        }

        this.imageExams = exams
      } finally {
        this.loadingImageExams = false
      }
    },
  },
}
</script>
